<template>
  <div class="form-wrap">
    <Menu :menu="menu" />
    <v-form ref="form">
      <v-card-text class="pa-0">
        <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
          >Название формы</v-card-title
        >
        <v-text-field v-model="form.name" :error-messages="getErrors('name')">
        </v-text-field>
      </v-card-text>
      <v-card-text class="pa-0">
        <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
          >Текст после успешной отправки формы</v-card-title
        >
        <v-text-field
          v-model="form.success_text"
          :error-messages="getErrors('success_text')"
        >
        </v-text-field>
      </v-card-text>
      <v-card-text class="pa-0">
        <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
          >Текст кнопки отправки</v-card-title
        >
        <v-text-field
          v-model="form.button_text"
          :error-messages="getErrors('button_text')"
        >
        </v-text-field>
      </v-card-text>
      <v-card-text class="pa-0">
        <v-card-title class="subtitle-1 pr-0 pl-0 pb-0">
          Поля формы
        </v-card-title>
        <v-card>
          <template>
            <v-select
              :items="formItems"
              label="Выберите тип поля для добавления"
              filled
              dark
              class="blue darken-3"
              item-text="field"
              item-value="type"
              :hide-details="true"
              v-model="fieldType"
            ></v-select>
          </template>
          <v-btn
            class="mx-2 mt-2"
            fab
            dark
            color="indigo"
            @click="createItem()"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
          <v-list v-if="form.items.length">
            <v-list-item v-for="(item, ind) in form.items" :key="ind">
              <v-list-item-content @click="editItem(item, ind)">
                <v-list-item-title
                  class="d-flex justify-space-between pr-8 pl-4"
                >
                  {{ item.title }}
                  <em> {{ item["field_name"] }} </em>
                </v-list-item-title>
              </v-list-item-content>
              <v-btn color="red" @click="deleteItem(ind)" dark>
                <v-icon center>mdi-delete</v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
        </v-card>
        <div class="red--text" v-html="getErrors('items')"></div>
        <v-spacer></v-spacer>
        <v-card-actions class="d-flex justify-space-between mt-5">
          <router-link :to="`/forms/?landing_id=${getCurrentLandingId()}`">
            <v-btn depressed>Отмена</v-btn>
          </router-link>
          <v-btn color="primary" class="ml-5" @click="submit">Сохранить</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
    <v-dialog v-model="dialog" max-width="720px">
      <v-card class="pa-2 rounded-br-2">
        <v-card-text>
          <v-card-title>
            <span class="headline">{{
              formSchema[editedItem.field_name].title
            }}</span>
          </v-card-title>
          <v-form ref="form">
            <div
              class="json-row"
              v-for="(schemaItem, key) in formSchema[editedItem.field_name]
                .children"
              :key="key"
            >
              <div
                :class="{
                  'd-none':
                    schemaItem.onlyDeveloper && !$store.getters.isDeveloper
                }"
              >
                <Field
                  :item-title="schemaItem.title"
                  :landing-id="getCurrentLandingId()"
                  :item-key="schemaItem.name"
                  :json-item="editedItem"
                  :schema-item="schemaItem"
                  :is-hidden="
                    schemaItem.onlyDeveloper && !$store.getters.isDeveloper
                  "
                />
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Отмена</v-btn>
          <v-btn color="blue darken-1" text @click="save">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import errors from "@/mixins/errors";
import Menu from "@/components/Menu.vue";
import Field from "@/components/Field";
import { isEmpty } from "lodash";
import { GLOBAL } from "@/config/consts";
const formSchema = require("@/config/form_config.json");

export default {
  mixins: [errors],
  props: {
    formData: {
      type: Object,
      default: () => {},
      required: false
    }
  },
  components: {
    Menu,
    Field
  },
  computed: {
    menu() {
      return [
        { icon: "mdi-home", text: "На главную", link: "/" },
        {
          icon: "mdi-puzzle-plus",
          text: "Конструктор блоков",
          link: `/blocks?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-text",
          text: "Менеджмент",
          link: `/management?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-contacts",
          text: "Формы",
          link: `/forms?landing_id=${this.getCurrentLandingId()}`
        }
      ];
    },
    formItems() {
      return Object.keys(formSchema).map(function(key) {
        return {
          field: formSchema[key]["title"],
          type: key
        };
      });
    }
  },
  data() {
    return {
      form: {
        name: "",
        success_text: "",
        button_text: "",
        landing: "",
        items: []
      },
      fieldType: "input",
      dialog: false,
      editedItem: {
        field_name: "input"
      },
      defaultItem: {
        field_name: "input"
      },
      editedIndex: -1,
      global: GLOBAL,
      formSchema: formSchema
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    formData() {
      this.setForm();
    }
  },
  methods: {
    getCurrentLandingId() {
      return this.$route.query.landing_id;
    },
    submit() {
      this.$emit("submit", { ...this.form });
    },
    setForm() {
      if (isEmpty(this.formData)) {
        return false;
      }

      this.clearErrors();
      this.form = { ...this.formData };
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.$refs.form.resetValidation();
      this.clearErrors();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.form.items[this.editedIndex] = this.editedItem;
      this.close();
    },
    createItem() {
      this.editedItem["field_name"] = this.fieldType;
      this.editedIndex = this.form.items.length;
      this.dialog = true;
    },
    editItem(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(index) {
      if (confirm("Вы уверены, что хотите удалить этот элемент?")) {
        this.$delete(this.form.items, index);
      }
    }
  }
};
</script>
<style>
.form-wrap .v-list-item__content:hover {
  background: rgba(238, 238, 238, 0.85);
}
.router-link-active {
  text-decoration: none;
}
</style>
